import React from 'react';
import './App.css'; 
import { Route, Routes, } from 'react-router-dom';
 
import { ToastContainer } from 'react-toastify';
import AllRoutes from './routes/Routes';




function App() {
  
 

  return (
    <> 
      <AllRoutes />
      <ToastContainer />
    </>

  );
}

export default App;
